<template>
    <div id="doctor-login-container" class="m-auto">
        <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
                <div class="row">
                    <div class="p-5 w-100">
                        <div class="text-center">
                            <h1 class="h4 text-gray-900 mb-4">
                                <span>{{ isAdmin ? $t('ADMINISTRATION') : $t('CGA') }}</span> <span v-if="!twoFactorAuthenticationFormVisibility">{{$t('LOGIN')}}</span><span v-if="twoFactorAuthenticationFormVisibility">{{$t('AUTHENTICATION')}}</span>
                            </h1>
                        </div>
                        <b-alert :show="dismissCountDown"
                                 dismissible
                                 fade
                                 variant="danger"
                                 @dismissed="dismissCountDown = 0">
                            {{alertMessage}}
                        </b-alert>
                        <form v-show="!twoFactorAuthenticationFormVisibility" class="user" @submit.prevent="submitLoginForm">
                            <div class="form-group">
                                <input v-model="inputEmail" type="email" class="form-control form-control-user" aria-describedby="emailHelp" :placeholder="$t('EMAIL_ADDRESS')">
                            </div>
                            <div class="form-group">
                                <input v-model="inputPassword" type="password" class="form-control form-control-user" :placeholder="$t('PASSWORD')">
                            </div>
                            <button type="submit" class="btn btn-primary btn-user btn-block">{{$t('LOGIN')}}</button>
                        </form>
                        <hr>
                        <div v-if="!twoFactorAuthenticationFormVisibility" class="d-flex">
                            <router-link class="small" :to="forgotPassword">{{$t('FORGOT_PASSWORD')}}?</router-link>
                            <router-link class="small ml-auto" to="/register">{{$t('REGISTER')}}</router-link>
                        </div>
                        <form v-show="twoFactorAuthenticationFormVisibility" class="user" @submit.prevent="submitTwoFactorLoginForm">
                            <div class="form-group">
                                <b-form-input :state="validTwoFactorCode" v-model="inputTwoFactorCode" type="text" class="form-control form-control-user" placeholder="Two Factor Code"></b-form-input>
                            </div>
                            <button type="submit" class="btn btn-primary btn-user btn-block">{{$t('AUTHENTICATE')}}</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
        data() {
            return {
                languages: [],
                selectedLanguage: null,
                inputEmail: '',
                inputPassword: '',
                inputTwoFactorCode: '',
                twoFactorAuthenticationFormVisibility: false,
                validTwoFactorCode: null,
                forgotPassword: '/forgotten-password',
                dismissCountDown: 0,
                alertMessage: ''
            }
        },
        props: {
            isAdmin: [Boolean]
        },
        methods: {

            submitLoginForm: function () {
                let self = this;
                this.$store.dispatch("retrieveToken", {
                    'email': self.inputEmail,
                    'password': self.inputPassword,
                    'isAdmin': self.isAdmin
                })
                    .then(response => {
                        if (response.data.success == true) {
                            this.$router.push({ path: '/' });
                        }
                        else if (response.data.twoFactorAuthenticationRequired == true) {
                            self.twoFactorAuthenticationFormVisibility = true;
                        }
                        else {
                            this.alertMessage = response.data.message;
                            this.dismissCountDown = 3;
                        }

                    })
                    .catch(error => {

                    });
            },
            submitTwoFactorLoginForm: function () {
                let self = this;
                this.$store.dispatch("retrieveTokenTwoFactor", {
                    'email': self.inputEmail,
                    'password': self.inputPassword,
                    'twoFactorCode': self.inputTwoFactorCode,
                    'isAdmin': self.isAdmin
                })
                    .then(response => {
                        if (response.data.success) {
                            self.validTwoFactorCode = true;
                            this.$router.push({ path: '/' });
                        }
                        else {
                            self.validTwoFactorCode = false;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
        }
    }
</script>

<style lang="scss" scoped>

    #doctor-login-container {
        max-width: 320px;
    }
</style>